import React from 'react';
import styles from './NxStack.scss';
import clsx from 'clsx';
import NxGap from '../NxGap';



const NxStack = ({children, gap = NxGap.M}: { children: React.ReactNode, gap?: NxGap }): React.ReactElement => {
  const nonEmptyChildren = React.Children.toArray(children);

  return <div className={clsx(styles.container, styles[gap])}>
  {nonEmptyChildren}
  </div>;
};


export default NxStack;